import {APP_INITIALIZER, NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {RouterModule} from '@angular/router'
import {MediaModule} from '@spartacus/storefront'
import {MbCheckoutService} from './services/checkout.service'
import {RouterStateSerializer} from '@ngrx/router-store'
import {MbCustomSerializerService} from './services/mb-custom-serializer.service'
import {
  MbOrderdetailsInfotmationTileComponent
} from './components/information-tile/mb-orderdetails-information-tile/mb-orderdetails-infotmation-tile.component'
import {
  MbCheckoutInformationTileComponent
} from './components/information-tile/mb-checkout-information-tile/mb-checkout-information-tile.component'
import {MbLogoutAdapter} from './adapters/mb-logout.adapter'
import {MbOccLogoutAdapter} from './services/mb-logout/mb-occ-logout.adapter'
import {MbI18nModule} from '../translations/mb-i18n.module'
import {ProductSearchService} from '@spartacus/core'
import {MbProductSearchService} from './services/mb-product-search.service'

@NgModule({
  declarations: [
    MbOrderdetailsInfotmationTileComponent,
    MbCheckoutInformationTileComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MediaModule,
    MbI18nModule
  ],
  exports: [
    MbOrderdetailsInfotmationTileComponent,
    MbCheckoutInformationTileComponent
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (mbCheckoutService: MbCheckoutService) => () => mbCheckoutService.init(),
      deps: [MbCheckoutService],
      multi: true
    },
    {
      provide: RouterStateSerializer,
      useExisting: MbCustomSerializerService,
    },
    {
      provide: MbLogoutAdapter,
      useExisting: MbOccLogoutAdapter,
    },
    {
      provide: ProductSearchService,
      useExisting: MbProductSearchService,
    },
  ]
})
export class SharedModule {
}
